import { state } from './state';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';
import { Module } from 'vuex';
import { StoreType } from '@/types/store/store.type';
import { OfferStoreType } from '@/types/store/offer-store.type';

const namespaced: boolean = true;
export const offer: Module<OfferStoreType, StoreType> = {
  namespaced,
  state,
  actions,
  mutations,
  getters
};
